'use client';

import Gleap from 'gleap';
import { useEffect } from 'react';

export const GleapInit = () => {
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      // Please make sure to call this method only once!
      Gleap.initialize('Gi39vh4S73cMEy8Eb0liBITt3UIWbnMI');
    }
  });
};
